export const manifest = {
  screens: {
    scr_ym451d: { name: "Deadline Viewer", route: "/", state: {"viewMode":"viewer"}, position: {"x":1560,"y":220} },
    scr_s8zoeu: { name: "Admin Entry", route: "/", state: {"viewMode":"admin"}, position: {"x":160,"y":220} },
  },
  sections: {
    sec_br7b32: { name: "Admin Dashboard Flow", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_br7b32", children: [
      { kind: "screen", id: "scr_s8zoeu" },
      { kind: "screen", id: "scr_ym451d" },
    ] },
  ],
}
